import React from 'react';
import { useState } from 'react';
import shape1 from '../../images/shapes/shape_circle_1.webp';
import shape2 from '../../images/shapes/shape_section_divider_2.svg';

const roadmapData = [
  {
    badge: "Q2 - 2025",
    title: "Project Launch",
    items: [
      "Website & Social Media Launch",
      "Build Nimanode Community/Growth Campaigns",
      "$NMA   Token Generation Event",
      "$NMA Token Presale"
    ]
  },
  {
    badge: "Q3 - 2025",
    title: "Protocol Development",
    items: [
      "CoinGecko & Coinmarketcap Listing",
      "Dex listing",
      "Zero-Code Interface Prototype",
      "Developer Onboarding Programs"
    ]
  },
  {
    badge: "Q4 - Q2 2025",
    title: "Launch & Scale",
    items: [
      "CEX Listing",
      "Beta Testing of Prototype",
      "$NMA Governance Integration",
      "Launch of Zero-Code AI Agent Interface"
    ]
  },
  {
    badge: "Q1 - 2026",
    title: "Advanced Research & Integrations",
    items: [
      "Institutional Partnerships",
      "AgentMesh Protocol Research",
      "Cross-Chain Integrations",
      "Launch of AI Agent Marketplace",
    ]
  }
];

const RoadmapSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleMouseOver = (index) => {
    setActiveIndex(index);
  };

  return (
    <section id="id_ico_roadmap_section" className="ico_roadmap_section section_space mt-lg-5 section_decoration">
      <div className="container">
        <div className="ico_heading_block text-center mt-lg-5 pt-lg-5" data-aos="fade-up" data-aos-duration="600">
          <h2 className="heading_text mb-0">Roadmap</h2>
        </div>

        <div className="ico_roadmap_flexbox" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
          {roadmapData.map((block, index) => (
            <div
              key={index}
              className={`roadmap_block ${activeIndex === index ? "active" : ""}`}
              onMouseOver={() => handleMouseOver(index)}
            >
              <div className="badge">{block.badge}</div>
              <h3 className="heading_text">{block.title}</h3>
              <ul className="iconlist_block unordered_list_block">
                {block.items.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    <span className="iconlist_icon">
                      <i className="fa-solid fa-circle"></i>
                    </span>
                    <span className="iconlist_label">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="hover_shape">
                <img src={shape1} alt="Shape Circle" />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="decoration_item shape_divider_1">
        <img src={shape2} alt="Shape Divider" />
      </div>
    </section>
  );
};

export default RoadmapSection;